<template>
  <div>
    <input
      v-model="email"
      placeholder="email"
    >
    <input
      v-model="password1"
      placeholder="Ingrese su contraseña"
    >
    <input
      v-model="password2"
      placeholder="Ingrese nuevamente su contraseña"
    >
    <button @click="register">
      Continuar
    </button>
  </div>
</template>
<script>
import { authenticationService } from '../../_services';

export default {
    name: 'Register',
    data() {
        return {
            email: '',
            password2: '',
            password1: '',
        };
    },
    methods: {
        register() {
            authenticationService.register(this.email, this.password1, this.password2);
        },
    },
};
</script>
